import React from 'react'

interface DroppedRow {
  row: number
  reason: string
}

interface DuplicateGroup {
  rows: number[]
  kept: number | null
  dropped: DroppedRow[]
}

const isDuplicateGroup = (value: unknown): value is DuplicateGroup =>
  typeof value === 'object' &&
  value !== null &&
  Array.isArray((value as DuplicateGroup).rows)

// An empty array passes every() vacuously, which turned any empty list — an
// empty ignoredFields, say — into an empty duplicates table.
export const parseDuplicateGroups = (
  value: unknown
): DuplicateGroup[] | null =>
  Array.isArray(value) && value.length > 0 && value.every(isDuplicateGroup)
    ? value
    : null

const CELL: React.CSSProperties = {
  padding: '5px 10px',
  fontSize: 12.5,
  verticalAlign: 'top',
  borderTop: '1px solid #eef0f2',
}

const HEAD: React.CSSProperties = {
  padding: '5px 10px',
  fontSize: 11,
  fontWeight: 700,
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
  color: '#9ca3af',
  textAlign: 'left',
}

/**
 * One row per duplicated SSN, by position in the parsed file. Which employee a
 * position belongs to is deliberately not shown — an admin opens the file named
 * on this screen to look it up.
 */
function DuplicateGroups({ groups }: { groups: DuplicateGroup[] }) {
  return (
    <table style={{ borderCollapse: 'collapse', width: '100%' }}>
      <thead>
        <tr>
          <th style={HEAD}>Rows</th>
          <th style={HEAD}>Kept</th>
          <th style={HEAD}>Dropped</th>
        </tr>
      </thead>
      <tbody>
        {groups.map((group, index) => (
          <tr key={index}>
            <td style={{ ...CELL, fontFamily: 'monospace' }}>
              {group.rows.join(', ')}
            </td>
            <td
              style={{
                ...CELL,
                fontFamily: 'monospace',
                color: group.kept === null ? '#dc2626' : undefined,
                fontWeight: group.kept === null ? 600 : undefined,
              }}
            >
              {group.kept === null ? 'none' : group.kept}
            </td>
            <td style={CELL}>
              {group.dropped.map(({ row, reason }) => (
                <div key={row}>
                  <span style={{ fontFamily: 'monospace' }}>{row}</span>{' '}
                  <span style={{ color: '#6b7280' }}>{reason}</span>
                </div>
              ))}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}

export default DuplicateGroups
